import {Box, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';

const NoInterviews = () => {
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        bgcolor="white"
        mt={2}
        borderRadius="8px"
        py={{xxs: 10, md: 15}}
        mx={2}
        textAlign="center"
      >
        <Image
          src="https://job-static.hirist.com/V8/static/media/no-slot-icon.81463dec.svg"
          alt={'NoNotifications'}
          width={209}
          height={183}
          object-fit="contain"
        />
        <Typography
          fontSize={{xxs: 24, md: 32}}
          color="secondary.dark"
          fontWeight={400}
          mt={1}
        >
          No Interviews
        </Typography>
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Typography
            color="text.secondary"
            fontSize={{xxs: 16, md: 22}}
            fontWeight={300}
          >
            Currently no interviews are available
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default NoInterviews;
